import { ComputedRef, InjectionKey, Ref } from 'vue';

import { useAIChatState } from '@/composables/mcp/useAIChatState';

export const ProvidedIsSidebarOpened: InjectionKey<Ref<boolean>> = Symbol(
  'ProvidedIsSidebarOpened',
);

export const ProvidedExportLimitReached: InjectionKey<ComputedRef<boolean>> =
  Symbol('ProvidedExportLimitReached');

export const ProvidedIsSidebarCollapsed: InjectionKey<Ref<boolean>> = Symbol(
  'ProvidedIsSidebarCollapsed',
);

export const ProvidedOnboardingStepsLeft: InjectionKey<Ref<number>> = Symbol(
  'ProvidedOnboardingStepsLeft',
);

export const ProvidedHasCompletedOnboarding: InjectionKey<Ref<boolean>> =
  Symbol('ProvidedHasCompletedOnboarding');

export const ProvidedOpenAiChat: InjectionKey<() => void> =
  Symbol('OpenAiChat');
export const ProvidedAIChatState: InjectionKey<
  ReturnType<typeof useAIChatState>
> = Symbol('AIChatState');
